export default __webpack_public_path__ + "fc7a06fe3cd912f46bfb42d326cf688e.svg";